import {ExplanationTypeEnum} from '@doltech/utils/lib/constants';

import {AbstractReadingExplanation} from '../_extends/reading-explanation.store';

export const DetailOnlyExplanationStore = AbstractReadingExplanation.named(
  'DetailOnlyExplanation'
).props({
  type: ExplanationTypeEnum.DETAIL_ONLY,
});

